module.exports = __webpack_public_path__ + "img/FORTUNEJACK.96c0e294.svg";